import ClientsAxios from "../../client-axios";
import { ResponseEntity } from "../../dto/response";

const { COMMUNICATION_BASE_URL } = ClientsAxios;


export const getMasterAnnouncementList = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('announcement/admin-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}

export const CreateMasterAnnouncementService = async (formData: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('announcement/create', formData)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}


export const UpdateMasterAnnouncementService = async (formData: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('announcement/update', formData)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}

export const getUserAnnouncementListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('announcement/list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}

export const MarkAsReadAnnoucementService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('announcement/mark-read', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}


export const getUserUnreadAnnouncementListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('announcement/popups', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}


export const UpdateMasterAnnouncementStatusService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await COMMUNICATION_BASE_URL.post('announcement/status-update', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response.statusCode || 500, error.message, response.data?.message ? response.data.message : {})
    }
    return responseEntity
}